import { ThemeProvider } from '@mui/material';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useAuthSync } from './hooks/useAuthSync';
import { AppSnackbar } from './lib/components/complex/Snackbar';
import { customTheme } from './lib/styles/theme';
import { Login } from './pages/Login';
import { DashboardShell } from './parts/DashboardShell';
import { ProtectedRoute } from './routes/ProtectedRoute';

function App() {
    useAuthSync();
    return (
        <ThemeProvider theme={customTheme}>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <DashboardShell />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
                <AppSnackbar />
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
